import React from "react";

import { useForm } from "react-hook-form";

const VitalForm2 = (props) => {
  const { nextStep } = props;
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const onSubmit = (data) => {
    const form2 = {
      hr: {
        value: +data?.pulse,
        unit: "bpm",
      },
      rr: {
        value: +data?.respiratory_rate,
        unit: "bpm",
      },
    }
    sessionStorage.setItem('form2',JSON.stringify(form2));
    nextStep()
  };
  const onSkip = () => {
    nextStep()
  }
  return (
    <div>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="w-4/12 min-w-[200px]">
          <label
            htmlFor="pulse"
            className="text-black text-base font-medium font-['SF Pro Display'] pl-3 pb-2"
          >
            Pulse(bpm)
          </label>
          <input
            {...register("pulse", {
              required: true,
            })}
            id="pulse"
            name="pulse"
            type="number"
            autoComplete="off"
            autoCorrect="off"
            className=" bg-gray-200  flex h-9 w-full rounded-lg border border-input  px-3 py-1 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
          />
          {errors.pulse && (
            <p className="py-2 text-xs text-red-500">{"required"}</p>
          )}
        </div>
        <div className="flex flex-col sm:flex-row  my-2">
          <div className="w-full sm:w-4/12 min-w-[200px]">
            <label
              htmlFor="respiratory_rate"
              className="text-black text-base font-medium font-['SF Pro Display'] pl-3 pb-2"
            >
              Respiratory rate(bpm)
            </label>
            <input
              {...register("respiratory_rate", {
                required: true,
              })}
              id="respiratory_rate"
              name="respiratory_rate"
              type="number"
              autoComplete="off"
              autoCorrect="off"
              className=" bg-gray-200  flex h-9 w-full rounded-lg border border-input  px-3 py-1 text-base shadow-sm transition-colors   focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50"
            />
            {errors.respiratory_rate && (
              <p className="py-2 text-xs text-red-500">{"required"}</p>
            )}
          </div>
        </div>
        <div className="flex w-full gap-2 mt-8 sm:mt-10">
          <button
            className="bg-white rounded-[100px] border-2 border-blue-800 text-center flex shadow w-1/2"
            onClick={onSkip}
          >
            <div className="text-blue-800  font-semibold font-['SF Pro Display'] flex justify-center items-center  px-4 py-3 w-full">
              Skip
            </div>
          </button>
          <button
            className="bg-blue-800 rounded-[100px] text-center flex shadow hover:bg-blue-800/90  w-1/2"
            type="submit"
          >
            <div className="text-white  font-semibold font-['SF Pro Display']  flex justify-center items-center  px-4 py-3 w-full">
              Next
            </div>
          </button>
        </div>
      </form>
    </div>
  );
};

export default VitalForm2;
